/* eslint-disable eqeqeq */
import React, { useContext } from 'react';
import styled from 'styled-components';
import { PriceTestReportsContext } from '@/features/details/price-test-reports/context';
import { Card } from '@/components/card';
import { VSpace } from '@/components/spacing';
import {
  DeskHidden,
  MobileHidden,
} from '@/features/details/price-test-reports/shared';
import { Experience } from '@/webapi/use-experience-api';
import { PriceTestResponse } from '@/features/details/price-test-reports/api';
import { Pagination } from '@/components/pagination';
import { DesktopStats } from '@/features/details/price-test-reports/desktop-stats';
import { NoDateMessage } from '@/features/details/charts/no-data';
import { DailyReports } from '@/features/details/price-test-reports/daily-reports';
import { MoreMetrics } from '@/features/details/price-test-reports/more-metrics';
import { MobileDailyReport } from '@/features/details/price-test-reports/mobile-stats';
import { DeskTileHeader } from '@/features/details/price-test-reports/desk-tile-header';
import { MobileTileHeader } from '@/features/details/price-test-reports/mobile-tile-header';
import { ErrorBoundary } from '@/features/shared/error-boundary';

interface PriceTestProductsListProps {
  experience?: Experience;
  setExperience?: (e: Experience) => void;
}

const shouldShowNoDataBulb = (data: PriceTestResponse, loading: boolean) =>
  !(data?.products?.length > 0) && !loading;

export function PriceTestProductsList({
  experience,
  setExperience,
}: PriceTestProductsListProps) {
  const { data, loading, page, maxPages, setPage, total } = useContext(
    PriceTestReportsContext,
  );
  const showNoDataBulb = shouldShowNoDataBulb(data, loading);

  return (
    <div>
      {loading && data?.products?.length === 0 && (
        <div style={{ minHeight: `400px` }} />
      )}
      {showNoDataBulb ? (
        <NoDateMessage loading={loading} />
      ) : (
        <ErrorBoundary>
          {data?.products?.map((p) => (
            <>
              <MobileHidden>
                <DetailsCard key={p.pid}>
                  <DeskTileHeader p={p} />
                  <DesktopStats experience={experience} p={p} />
                </DetailsCard>
              </MobileHidden>
              <DeskHidden>
                <MobileTileHeader p={p} />
                <MobileDailyReport experience={experience} p={p} />
              </DeskHidden>
              <VSpace value={2} />
            </>
          ))}
          {total > 5 && (
            <>
              <VSpace value={2} />
              <Pagination
                value={page + 1}
                pageCount={maxPages}
                pageSize={5}
                total={total}
                loading={loading}
                onPageChanged={(page) => setPage(page - 1)}
                label="products"
              />
              <VSpace value={2} />
            </>
          )}
          {total == -5 && (
            <ErrorBoundary>
              <DailyReports
                experience={experience}
                setExperience={setExperience}
              />
              <MoreMetrics
                experience={experience}
                setExperience={setExperience}
              />
            </ErrorBoundary>
          )}
        </ErrorBoundary>
      )}
    </div>
  );
}

const DetailsCard = styled(Card)`
  && {
    cursor: default;
    display: grid;
    position: relative;
    padding: 3.5rem 2rem 3.5rem 3.5rem;
    @media (max-width: 768px) {
      padding: 3.5rem 2rem;
    }
    border-radius: 2rem;
  }
`;
